import { env } from "./env";

const raw = {
  auth: env.VITE_MOCK_AUTH,
  dashboard: env.VITE_MOCK_DASHBOARD,
  launches: env.VITE_MOCK_LAUNCHES,
  units: env.VITE_MOCK_UNITS,
  brokers: env.VITE_MOCK_BROKERS,
  network: env.VITE_MOCK_NETWORK,
  proposals: env.VITE_MOCK_PROPOSALS,
  media: env.VITE_MOCK_MEDIA,
  users: env.VITE_MOCK_USERS,
  settings: env.VITE_MOCK_SETTINGS,
  notifications: env.VITE_MOCK_NOTIFICATIONS,
  tickets: env.VITE_MOCK_TICKETS,
  subscription: env.VITE_MOCK_SUBSCRIPTION,
};

export type ModuleName = keyof typeof raw;

// Com MOCK_AUTH=true o accessToken é o literal "mock-token" — nenhum módulo
// real consegue chamar a API (não é JWT válido → 401 → refresh falha → logout).
// Força os demais flags pra true e avisa em dev pra impedir esse modo "zumbi".
if (raw.auth) {
  const mixed = (Object.keys(raw) as ModuleName[]).filter(
    (k) => k !== "auth" && !raw[k],
  );
  if (mixed.length > 0) {
    if (import.meta.env.DEV) {
      console.warn(
        `[mock-flags] VITE_MOCK_AUTH=true forçando mock em: ${mixed.join(", ")} ` +
          `(token é fake — APIs reais retornariam 401).`,
      );
    }
    for (const k of mixed) raw[k] = true;
  }
}

export const mockFlags: Readonly<typeof raw> = raw;

export function isMockEnabled(mod: ModuleName): boolean {
  return mockFlags[mod];
}

export function listActiveMocks(): ModuleName[] {
  return (Object.keys(mockFlags) as ModuleName[]).filter((m) => mockFlags[m]);
}

export function hasAnyMock(): boolean {
  return listActiveMocks().length > 0;
}
